(function (angular) {
  "use strict";

  angular
    .module("app")
    .controller("manageAttendanceController", manageAttendanceController);

  manageAttendanceController.$inject = [
    "$scope",
    "$rootScope",
    "modalService",
    "$uibModalInstance",
    "eventId", // injected by parent controller
    "EventsApi",
    "EventOrdersApi",
    "handleError",
    "Users",
    "$timeout",
    "stripeKey",
    "alerts",
    "ticketId",
  ];

  function manageAttendanceController(
    $scope,
    $rootScope,
    modalService,
    $uibModalInstance,
    eventId,
    EventsApi,
    EventOrdersApi,
    handleError,
    Users,
    $timeout,
    stripeKey,
    alerts,
    ticketId,
  ): void {
    $scope.thisUser = $rootScope.thisUser;
    $scope.card = null;
    $scope.event = null;
    $scope.isLoading = false;
    $scope.loadingMessage = "";
    $scope.numTickets = 1;
    $scope.attendees = [];
    $scope.orderCost = null;
    $scope.formErrors = {};
    $scope.confirmOrder = false;
    $scope.orderConfirmed = false;
    $scope.returnData = false; // If this is set to true, we will always close() instead of dismiss() so we can send data to parent controller
    $scope.subevents = [];
    $scope.attrs = [];

    $scope.attr_text = [];
    $scope.attr_select = [];
    $scope.attr_check = [];

    // update $scope.numTickets from ngChange (ngModel not binding?)
    $scope.setNumTickets = function (e) {
      $scope.numTickets = e.numTickets;
    };

    $scope.setTextAttr = function (e) {
      $scope.attr_text[e.field.key] = e.attr_text;
    };
    //come back to this as right now its adding a hashkey value too it seems
    $scope.setTSelectAttr = function (e) {
      //for some reason this currently sets an extra variable with $$ at the start
      try {
        JSON.parse(e.attr_select);
        $scope.attr_select[e.field.key] = e.attr_select;
      } catch (l) {
        $scope.attr_select[e.field.key] = e.attr_select;
      }
    };
    //come back to this as its setting it like 1: true, when it should probably have the field name
    $scope.setCheckAttr = function (e) {
      if ($scope.attr_check.hasOwnProperty(e.field.label)) {
        $scope.attr_check[e.field.label].push(e.val.value);
      } else {
        $scope.attr_check[e.field.label] = [e.val.value];
      }
    };

    // methods
    $scope.dismiss = $uibModalInstance.dismiss;
    $scope.close = close;
    $scope.reserveTickets = reserveTickets;
    $scope.purchaseTickets = purchaseTickets;
    $scope.cancelOrder = cancelOrder;
    $scope.cancelTicket = cancelTicket;
    $scope.refreshSubevents = refreshSubevents;

    if (!eventId) {
      $scope.forceClose = true;
      $scope.dismiss();
      handleError("No eventId provided to controller");
      return;
    }

    /**
     * Loads the event from the API
     * @return {void}
     */
    function getData(eventId, ticketId) {
      $scope.isLoading = true;

      EventsApi.get(
        {
          id: eventId,
          with: "[children, tickets]",
        },
        function (response) {
          $scope.isLoading = false;
          $scope.event = response.data;

          $scope.attrs = JSON.parse($scope.event.custom_attrs);
          for (let i = 0, len = $scope.event.tickets.length; i < len; i++) {
            if ($scope.event.tickets[i].id === ticketId) {
              $scope.ticket = $scope.event.tickets[i];
            }
          }

          if ($scope.event.userOrder && $scope.event.userOrder.subevents) {
            $scope.subevents = $scope.event.userOrder.subevents;
          } else {
            $scope.subevents = [];
          }

          $scope.event.children = $scope.event.children.map(function (child) {
            const startsAt = window.moment(child.starts_at);
            const endsAt = window.moment(child.ends_at);

            if (endsAt.isValid()) {
              child.information = [
                startsAt.format("ddd Do MMM YYYY hh:mma"),
                startsAt.isSame(endsAt, "day")
                  ? endsAt.format("hh:mma")
                  : endsAt.format("ddd Do MMM YYYY hh:mma"),
              ].join(" - ");
            } else {
              child.information = startsAt.format("ddd Do MMM YYYY hh:mma");
            }

            child.title_formatted =
              child.title +
              (child.price > 0 ? " (+" + child.price_formatted + ")" : "");

            return child;
          });

          $scope.approvedChildEvents = $scope.event.children.filter(
            function (subevent) {
              return subevent.status === "approved";
            },
          );
        },
        function (err) {
          $scope.isLoading = false;
          handleError(err);
        },
      );
    }

    /**
     * Turn and array into an object;
     * @param field
     */
    function arrayToObject(field) {
      const textObj = {};

      const textKeys = Object.keys(field);
      if (textKeys.length > 0) {
        for (const task of textKeys) {
          textObj[task] = field[task];
        }
      }
      return textObj;
    }

    /**
     * Request a payment method if required
     * @return {void}
     */
    function reserveTickets() {
      $scope.subevents = $scope.event.children
        .filter(function (child) {
          return child.checked;
        })
        .map(function (child) {
          return child.id;
        });

      //Turn the array into an object so its handled in the passing of the data
      $scope.attr_text = arrayToObject($scope.attr_text);
      $scope.attr_select = arrayToObject($scope.attr_select);
      $scope.attr_check = arrayToObject($scope.attr_check);

      // if online payment required, stripe is configured and card not set.
      if ($scope.event.payment_required && stripeKey && !$scope.card) {
        // open card modal.
        Users.manageCard().result.then(function (card) {
          $scope.card = card;
          $scope.confirmOrder = true;
        });
      } else {
        $scope.confirmOrder = true;
      }

      EventOrdersApi.cost(
        {
          event_id: $scope.event.id,
          "subevents[]": $scope.subevents,
          total_tickets: $scope.numTickets,
          attr_text: $scope.attr_text,
          attr_check: $scope.attr_check,
          attr_select: $scope.attr_select,
          ticket_id: $scope.ticket.id,
        },
        function handleCostResponse(response) {
          $scope.orderCost = response.data;
        },
      );

      // Add attendee placeholders
      $scope.attendees = [];

      //If no attendee we need to get the users name
      if ($scope.thisUser == undefined) {
        $scope.attendees.push({
          full_name: "",
          email: "",
        });
      }

      for (let i = 0; i < $scope.numTickets - 1; i++) {
        $scope.attendees.push({
          full_name: "",
          email: "",
        });
      }
      $scope.selectedAttendee = $scope.attendees[0];
    }

    /**
     * Contacts the API to reserve tickets
     * @return {void}
     */
    function purchaseTickets() {
      $scope.isLoading = true;
      $scope.loadingMessage = "Reserving your tickets...";

      const request: Record<string, any> = {
        event_id: $scope.event.id,
        subevents: $scope.subevents,
        total_tickets: $scope.numTickets,
        attr_text: $scope.attr_text,
        attr_check: $scope.attr_check,
        attr_select: $scope.attr_select,
        attendees: $scope.attendees,
        ticket_id: $scope.ticket.id,
      };

      if ($scope.event.payment_required) {
        request.stripe_id = $scope.card.stripe_id;
      }

      EventOrdersApi.reserve(
        request,
        function (response) {
          angular.extend($scope.event, response.data.event);

          alerts.emit({
            theme: "success",
            title: "Tickets Purchased",
            messages: [
              $scope.numTickets +
                " ticket" +
                ($scope.numTickets > 1 ? "s" : "") +
                " purchased for " +
                $scope.event.title,
            ],
          });

          $scope.orderConfirmed = true;
          $scope.isLoading = false;
        },
        function () {
          $scope.isLoading = false;
        },
      );
    }

    /**
     * Hides "Confirm Your Order" box
     * @return {void}
     */
    function cancelOrder() {
      $scope.card = null;
      $scope.confirmOrder = false;
    }

    /**
     * Cancels the user's order to this event
     * @return {void}
     */
    function cancelTicket() {
      $scope.isLoading = true;
      $scope.loadingMessage = "Cancelling your order...";

      EventOrdersApi.delete(
        {
          id: $scope.event.userOrder.id,
        },
        function () {
          // Wait to make the interface prettier
          $timeout(function () {
            delete $scope.event.userOrder;
            $scope.event.total_redeemed_tickets--;
            $scope.event.total_unredeemed_tickets++;

            $scope.isLoading = false;
            $scope.returnData = true;

            alerts.emit({
              theme: "success",
              title: "Order Cancelled",
              messages: [
                "Your order for this event has been cancelled successfully",
              ],
            });
          }, 500);
        },
        function (err) {
          $scope.isLoading = false;
          handleError(err);
        },
      );
    }

    /**
     * Closes the modal and returns the event
     * @return {void}
     */
    function close() {
      $uibModalInstance.close($scope.event);
    }

    /**
     * Function that checks what subevents have been checked and refreshes
     * the current state of the subevents for use in the ticket directive.
     * @return {void}
     */
    function refreshSubevents() {
      $scope.subevents = [];

      $scope.approvedChildEvents.map(function (subevent) {
        if (subevent.checked) {
          $scope.subevents.push(subevent.id);
        }
      });
    }

    // Catch the modal being closed for any reason
    $scope.$on("modal.closing", function (event, reason, closed) {
      if (!closed && !$scope.forceClose) {
        return event.preventDefault();
      }
    });

    getData(eventId, ticketId);
  }
})(angular);
